import getGlobalSettingsAccountMailboxInfo from 'owa-account-source-list-store/lib/selectors/getGlobalSettingsAccountMailboxInfo';
import { logUsage } from 'owa-analytics';
import { checkMaxEventsPerSessionCount } from 'owa-analytics-utils/lib/checkMaxEventsPerSessionCount';
import { getMicrosoft365UpsellMode, isMicrosoft365UpgradeMode } from './getMicrosoft365UpsellMode';

export function logPersistentHeaderButtonShown(): void {
    if (!checkMaxEventsPerSessionCount('HeaderBuyMicrosoft365ButtonShown', 1)) {
        return;
    }

    const mailboxInfo = getGlobalSettingsAccountMailboxInfo();
    logUsage('HeaderBuyMicrosoft365ButtonShown', mailboxInfo, {
        IsUpgrade: isMicrosoft365UpgradeMode(getMicrosoft365UpsellMode(mailboxInfo)),
    });
}

export function logPersistentHeaderButtonHovered(): void {
    const mailboxInfo = getGlobalSettingsAccountMailboxInfo();
    logUsage('HeaderBuyMicrosoft365ButtonHovered', mailboxInfo, {
        IsUpgrade: isMicrosoft365UpgradeMode(getMicrosoft365UpsellMode(mailboxInfo)),
    });
}
